import React from "react";
import { images, advantages } from "../data/content";
export function Advantages() {
  return <section id="avantages" className="scroll-mt-20 bg-ink py-24 text-white md:py-36" data-id="element-20" data-mp="33brm4mow2de6">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10" data-id="element-21" data-mp="3har79kd70a5l">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-22" data-mp="3h8wxn27dg4gt">
          <h2 className="text-[40px] font-semibold leading-[1] tracking-[-0.035em] md:text-[72px] lg:col-span-8" data-id="element-23" data-mp="3cbn0f0dqqoif">
            Pourquoi choisir <span className="font-serif font-normal italic text-brand" data-id="element-24" data-mp="2omvgewab1cgq">SAFTI</span> pour lancer votre activité ?
          </h2>
          <p className="self-end text-[17px] leading-relaxed text-white/70 lg:col-span-4" data-id="element-25" data-mp="2jleeqyjzxlz3">
            Six raisons concrètes qui font la différence entre un métier qu'on subit et une activité qu'on construit.
          </p>
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-12 lg:gap-10" data-id="element-26" data-mp="25v2iqokaj32o">
          <div className="lg:col-span-4" data-id="element-27" data-mp="20wr9og1tkwli">
            <div className="lg:sticky lg:top-28" data-id="element-28" data-mp="20vyca5or3jg1">
              <img src={images.advisor} alt="Une conseillère remet les clés d'un appartement à un couple" className="aspect-[4/5] w-full object-cover" data-id="element-29" data-mp="3gna1e48ydrcy" />
            </div>
          </div>
          <ul className="lg:col-span-7 lg:col-start-6" data-id="element-30" data-mp="3qed1b2q5c0an">
            {advantages.map(a => <li key={a.title} className="grid gap-3 border-t border-white/15 py-8 md:grid-cols-[1fr_1.2fr] md:gap-10" data-id="element-31" data-mp="3udluo6h9xw5o">
                <h3 className="text-[24px] font-medium leading-tight tracking-[-0.02em]" data-id="element-32" data-mp="2xq8tobo0ld5b">{a.title}</h3>
                <p className="text-[16px] leading-relaxed text-white/65" data-id="element-33" data-mp="32nr3s5drpyew">{a.text}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}